import Modal from './Modal';

export default function DeactivateModal({selectedName, handleDeactivate, setShowModal2}) {
    return (
    <Modal>
        <h3 className="text-lg font-bold text-center text-docpgrPurple">
            confirm deactivation
        </h3>
        <p className="mt-2 mb-6 text-center text-slate-600">
            Are you sure you want to deactivate <strong>{selectedName}</strong>?
        </p>
        <div className="flex space-x-3">
            <button onClick={() => handleDeactivate()} className="w-full rounded-lg border border-red-300 bg-red-50 px-4 py-2 text-sm font-semibold text-red-700 hover:bg-red-100 transition">
                Deactivate
            </button>
            <button onClick={() => setShowModal2(false)} className="w-full rounded-lg border border-slate-300 bg-slate-50 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-100 transition">
                Cancel
            </button>
        </div>
    </Modal>
    )
}